var redefine = require('./$.redefine');
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/$.redefine-all.js
// module id = 36
// module chunks = 0